import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import { Grid, IconButton, InputAdornment, Menu, MenuItem, Stack, TablePagination, TextField, useMediaQuery } from '@mui/material';

// assets
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import HeightIcon from '@mui/icons-material/Height';
import MoreHorizTwoToneIcon from '@mui/icons-material/MoreHorizTwoTone';
import SearchIcon from '@mui/icons-material/Search';

// ==============================|| MAIL LIST HEADER ||============================== //

const MailListHeader = ({
    search,
    handleSearch,
    length,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    handleDrawerOpen,
    handleDenseTable
}) => {
    const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const [anchorEl, setAnchorEl] = useState(null);
    const handleClickSort = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseSort = () => {
        setAnchorEl(null);
    };

    return (
        <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs>
                <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1.5}>
                    <IconButton onClick={handleDrawerOpen} size="small">
                        <MenuRoundedIcon fontSize="small" />
                    </IconButton>
                    <IconButton onClick={handleDenseTable} size="small">
                        <HeightIcon fontSize="small" />
                    </IconButton>
                    <IconButton onClick={handleClickSort} size="small">
                        <MoreHorizTwoToneIcon fontSize="small" />
                    </IconButton>
                   
                </Stack>
            </Grid>
            
        </Grid>
    );
};

MailListHeader.propTypes = {
    search: PropTypes.string,
    length: PropTypes.number,
    rowsPerPage: PropTypes.number,
    page: PropTypes.number,
    handleSearch: PropTypes.func,
    handleChangeRowsPerPage: PropTypes.func,
    handleChangePage: PropTypes.func,
    handleDrawerOpen: PropTypes.func,
    handleDenseTable: PropTypes.func
};

export default MailListHeader;
